export const TABLE_TYPE = {
  TEXT: 'text',
  DATA: 'data',
  UNKNOWN: ''
}

export const DEFAULT_STRING_JOIN = ', '
export const LABEL_COLUMN_MIN_WIDTH = 290
export const DATA_COLUMN_DEFAULT_WIDTH = 180
